import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { extractPolicyRecord, updatePolicy, getPolicy, isEmptyPolicyContent } from ".";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { AdminPageLayout, AdminSectionCard } from "../../components/admin/AdminPageLayout";
import { AdminAction } from "../../components/admin";

export default function UpdatePrivacy() {
  const navigate = useNavigate();
  const [policy, setpolicy] = useState("");
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);

  const quillModules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      ["link"],
    ],
  };

  const quillFormats = ["bold", "italic", "underline", "strike", "link"];

  const handleUpdatePolicy = async () => {
    if (isEmptyPolicyContent(policy)) {
      toast.error("Policy content cannot be empty.", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light",
      });
      return;
    }

    setLoading(true);
    try {
      const data = { policy };
      const response = await updatePolicy(data);
      if (response) {
        navigate(`/privacypolicy`, { replace: true, state: { results: true } });
      }
    } catch (error) {
      const message =
        error?.response?.data?.message || "Error updating Policy!";
      toast.error(message, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light",
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setFetching(true);
    try {
      const response = await getPolicy();
      const record = extractPolicyRecord(response.data);
      setpolicy(record?.policy || "");
    } catch (error) {
      console.log(error);
      toast.error("Failed to load privacy policy.", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light",
      });
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <AdminPageLayout
      eyebrow="Policy & Compliance"
      title="Update Privacy Policy"
      description=""
    >
      <AdminSectionCard title="Update the Private Policy Content" description="">
        <div className="p-6">
          <div>
            <label className="text-sm font-medium text-slate-700 mb-2 block">
              Policy Content
            </label>
            <div className="quill-wrapper">
              <ReactQuill
                theme="snow"
                value={policy}
                onChange={setpolicy}
                modules={quillModules}
                formats={quillFormats}
                placeholder="Enter privacy policy content..."
                style={{ minHeight: "320px" }}
                readOnly={fetching || loading}
              />
            </div>
          </div>

          <div className="mt-6 flex justify-end">
            <AdminAction
              onClick={handleUpdatePolicy}
              loading={loading}
              disabled={fetching || loading}
            >
              Update Content
            </AdminAction>
          </div>
        </div>
      </AdminSectionCard>
    </AdminPageLayout>
  );
}
